export interface IDealResource {
  upsertDeal(data: Deal): Promise<{ deal_id: string; ipAddress: string }>;
  getDeal(dealId: string): Promise<Deal | undefined>;
  setShareableCode(value: string): void;
}

export enum OrdersPerDay {
  LessThan10 = '1',
  MoreThan10 = '2',
}

export enum WaiterTables {
  LessThan15 = '1',
  Between15And30 = '2',
  MoreThan30 = '3',
}

export enum WaiterQuantities {
  LessThan3 = '1',
  Between3And5 = '2',
  MoreThan5 = '3',
}

export interface Deal {
  deal_id?: string;
  name: string;
  first_name: string;
  email: string;
  phone: string;
  order_day?: OrdersPerDay;
  company: string;
  computer: boolean;
  computer_access_label: string;
  acceptTerms: boolean;
  ipAddress?: string;
  waiter_quantity?: WaiterQuantities;
  waiter_tables?: WaiterTables;
  force_central_account?: boolean;
  force_billing_core_subscription?: boolean;
  invoicing?: string;

  /** for overriding */
  shareableCode?: string;
  analytics_id?: string;
}

export interface DealCustomField {
  key?: string;
  value: string;
}

export interface DealCompany {
  _id: string;
  name: string;
  email: string;
  phone: string;
}

export interface DealContact {
  _id: string;
  name: string;
  email: string;
  phone: string;
}

export interface DealFitting {
  contain: boolean;
  matches: string;
  type: string;
}

export interface Responsible {
  name: string;
  external_id: string;
}

export interface UpsertDealUpdateDate {
  _id: string;
  updateDate: string;
}

export interface UpsertDealResponsibleHistory {
  _id: string;
  name: string;
  email: string;
  external_id: string;
}

export interface UpsertDealSubmitFormData {
  _id: string;
  name: string;
  companyName: string;
  site_origem: string;
  computer: string;
  order_day: string;
  phone: string;
  email: string;
  analytics_id: string;
  lead_ip: string;
  application: string;
  last_registration_date: string;
  lead_type: string;
  register_shortlink: string;
}

export interface DealSubmitFormData {
  force_billing_core_subscription: string;
  force_central_account: string;
  invoicing: string;
}

export interface GetDealResponse {
  data: {
    id: string;
    name: string;
    contacts: DealContact[];
    customFields: DealCustomField[];
    companies: DealCompany[];
    ipAddress: string;
    submit_form_data: DealSubmitFormData[];
  };
}

export interface UpsertDealActivity {
  _id: string;
  title: string;
  responsible: Responsible;
  activityType: { externalId: string };
  status: 'OPEN' | string;
  action: 'created' | string;
  externalId: string;
  update_history: [];
}
export interface ExternalId {
  key: string;
  value: string;
}

export interface UpsertDeal {
  __v: number;
  _id: string;
  name: string;
  status: string;
  stage: string;
  notes: [];
  contacts: DealContact[];
  companies: DealCompany[];
  customFields: DealCustomField[];
  externalIds: ExternalId[];
  update_dates: UpsertDealUpdateDate[];
  submit_form_data: UpsertDealSubmitFormData[];
  responsible_history: UpsertDealResponsibleHistory[];
  createdAt: string;
  updatedAt: string;
  leadIp: string;
  activities: UpsertDealActivity[];
  update_amount: number;
  responsible: Responsible;
  fitting: DealFitting;
}
export type UpsertDealParams<T = Partial<{}>> = Omit<Deal, 'waiter_quantity' | 'waiter_tables'> & {
  [key in keyof T]: unknown;
};

export interface UpsertDealResponse {
  data: {
    dealId: string;
    isUpdate: boolean;
    isSelfService: boolean;
    register_shortlink: string;
    deal: UpsertDeal;
    analytics_id: string;
    ipAddress: string;
    responsible: Responsible;
    /** runtime only */
    body: { [key: string]: never };
  };
}

export interface FreemiumValidateEmailResponse {
  success: boolean;
  data: {
    deal: { customFields: DealCustomField[]; companies: DealCompany[]; contacts: DealContact[] } & Deal;
  };
}
